import {WithTranslation, withTranslation} from 'react-i18next';
import {Redirect} from 'react-router-dom';

const RedirectToLocalizedPage = (props: IRedirectToLocalizedPageProps) => {
	return <Redirect to={`/${props.i18n.language}/`} />;
};

type IRedirectToLocalizedPageProps = WithTranslation;

export default withTranslation()(RedirectToLocalizedPage);
